import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { appPaths } from '../../../app.paths';

@Component({
  selector: 'review-bar',
  imports: [],
  templateUrl: './review-bar.component.html',
  styleUrl: './review-bar.component.scss'
})
export class ReviewBarComponent {
  @Input() isUpdated = false;
  @Input() dateText = 'in June 2026';

  isSpanishPage = inject(Router).url.includes(`/${appPaths.SPANISH}`);
}
